import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "flowbite"

// Connects to data-controller="custom-tooltip"
// This is a custom trigger for the flowbite tooltip
// if we would have named it the tooltip controller it would interfer with the flowbite tooltip itself
export default class extends Controller {
  static targets = ["trigger", "content"]
  static values = { placement: String }

  connect() {
    this.boundRecreateFrameTooltip = this.recreateFrameTooltip.bind(this)
    this.boundRecreateTooltip = this.recreateTooltip.bind(this)

    this.initializeTooltip()
    document.addEventListener(
      "turbo:frame-load",
      this.boundRecreateFrameTooltip,
    )
    window.addEventListener("turbo:morph", this.boundRecreateTooltip)
  }

  disconnect() {
    document.removeEventListener(
      "turbo:frame-load",
      this.boundRecreateFrameTooltip,
    )
    window.removeEventListener("turbo:morph", this.boundRecreateTooltip)
    this.destroyTooltip()
  }

  recreateFrameTooltip(event) {
    const frameId = event.target.id

    if (frameId.includes("_tooltip_content")) {
      this.recreateTooltip()
    }
  }

  recreateTooltip() {
    if (!this.element.isConnected) return

    this.destroyTooltip()
    this.initializeTooltip()
  }

  initializeTooltip() {
    if (this.hasContentTarget) {
      const options = this.hasPlacementValue
        ? { placement: this.placementValue }
        : undefined

      this.tooltip = new Tooltip(
        this.contentTarget,
        this.triggerTarget,
        options,
      )
    }
  }

  destroyTooltip() {
    this.tooltip?.destroy()
    this.tooltip = null
  }
}
